// Hooks
import { useTransformStringOnOffset } from '@/utils/hooks/format/useTransformString';

import PropTypes from 'prop-types';

import { FB_POST_ICONS } from '@/lib/posts/postIcon';
import { FB_POST_TYPES, getPostType } from '@/lib/posts/postTypes';
// Lib
import { FACEBOOK } from '@/lib/socialProfile';

// Components
import Post from '@/components/base/Post';
import { AlbumPostIcon } from '@/components/pages/albums/AlbumFunnelModal/ModalSteps/ManualStep/components/post/AlbumPostIcon';

const FacebookAlbumPost = ({ data, shouldDisplayIcon }) => {
    const { OffsetReplace, formatFacebookText } = useTransformStringOnOffset();

    const type = getPostType({
        network: FACEBOOK,
        type: data?.type,
        mediasLength: data?.medias?.length
    });

    return (
        <Post data={data} className="w-full">
            <Post.Content className="relative w-full text-left text-sm">
                <AlbumPostIcon
                    show={type !== FB_POST_TYPES.TYPE_PHOTO && shouldDisplayIcon}
                    type={FB_POST_ICONS[type]}
                />

                {(type === FB_POST_TYPES.TYPE_STATUS && data?.caption !== '') ||
                (type === FB_POST_TYPES.TYPE_PHOTO &&
                    data?.medias?.[0]?.type === 'link' &&
                    !data?.medias?.[0]?.image) ? (
                    <Post.Status
                        style="album"
                        withMedia={false}
                        formattedCaption={
                            data?.medias?.[0]?.type === 'link' && data?.caption === '' ? (
                                data?.medias?.[0]?.target ?? ''
                            ) : (
                                <OffsetReplace
                                    text={formatFacebookText(data?.caption, data?.tags, 'span')}
                                    components={{
                                        span: <span className="text-icoBlue" />,
                                        br: <br />,
                                        p: <p />
                                    }}
                                />
                            )
                        }
                    />
                ) : (
                    <div className="square relative">
                        <Post.Image />
                    </div>
                )}
            </Post.Content>
        </Post>
    );
};

FacebookAlbumPost.propTypes = {
    data: PropTypes.object
};

export default FacebookAlbumPost;
